import { Icon } from '@purpur/library/icon';
import styled from 'styled-components';

import { purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

import { RoundFilledIcon } from '../RoundFilledIcon/RoundFilledIcon';

export const IconModeDesktop = styled(RoundFilledIcon).attrs({ size: 'lg' })``;
export const IconModeMobile = styled(Icon).attrs({ size: 'md' })``;

const iconModeDesktopSelector: string = IconModeDesktop;
const iconModeMobileSelector: string = IconModeMobile;

export const DualMode = styled.span.attrs({ role: 'presentation' })`
    ${purpurMedia('sm')`
        ${iconModeDesktopSelector} { display: none; }
        ${iconModeMobileSelector} { display: flex; }
    `}
    ${purpurMedia('lg')`
        ${iconModeDesktopSelector} { display: flex; }
        ${iconModeMobileSelector} { display: none; }
    `}
`;
